import { render } from "./BrownCards.vue?vue&type=template&id=6d190459"
import script from "./BrownCards.vue?vue&type=script&lang=js"
export * from "./BrownCards.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BrownCards.vue?vue&type=style&index=0&id=6d190459&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__